import { createSlice } from "@reduxjs/toolkit";

const initialTicketState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  ticketForEdit: undefined,
  validErpForTicketEdit: undefined,
  ticketLogReschedule: [],
  complainHistory: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const ticketSlice = createSlice({
  name: "ticket",
  initialState: initialTicketState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    ticketFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    ticketRescheduleFetched: (state, action) => {
      const { entities } = action.payload;
      state.ticketLogReschedule = entities;
    },
    ticketAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    ticketCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.ticket.push(action.payload.ticket);
    },
    ticketDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.ticket.filter(el => el.ticket_id !== action.payload.id);
    },
    getTicket: (state, action) => {
      state.actionsLoading = false;
      state.ticketForEdit = action.payload.ticketForEdit;
      state.error = null;
    },
    getValidErpTicket: (state, action) => {
      state.actionsLoading = false;
      state.validErpForTicketEdit = action.payload.validErpForTicketEdit;
      state.error = null;
    },
    getHistoryClient: (state, action) => {
      state.actionsLoading = false;
      state.complainHistory = action.payload.complainHistory;
      state.error = null;
    },
    // updateProduct
    ticketUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.ticket = state.entities.ticket.map(entity => {
        if (entity.ticket_id === action.payload.ticket.ticket_id) {
          return action.payload.ticket;
        }
        return entity;
      });
    },
  },
});
